export default __webpack_public_path__ + "static/media/urgentAction.fb13618d.svg";